'use strict';

var jsxRuntime = require('react/jsx-runtime');

const MediumPrivate = ({ testId, className, solid })=>{
    return jsxRuntime.jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: solid ? jsxRuntime.jsxs(jsxRuntime.Fragment, {
            children: [
                jsxRuntime.jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M0.800049 8.01468C0.800049 6.29672 2.2576 4.96667 3.97624 4.96667H12.0239C13.7425 4.96667 15.2 6.29672 15.2 8.01468V12.652C15.2 14.37 13.7425 15.7 12.0239 15.7H3.97624C2.2576 15.7 0.800049 14.37 0.800049 12.652V8.01468Z",
                    fill: "currentColor"
                }),
                jsxRuntime.jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M7.88182 1.69999C6.68265 1.69999 5.74546 2.63976 5.74546 3.76499V5.72499H4.34546V3.76499C4.34546 1.83355 5.94289 0.299988 7.88182 0.299988C9.82076 0.299988 11.4182 1.83355 11.4182 3.76499V5.72499H10.0182V3.76499C10.0182 2.63976 9.08099 1.69999 7.88182 1.69999Z",
                    fill: "currentColor"
                })
            ]
        }) : jsxRuntime.jsxs(jsxRuntime.Fragment, {
            children: [
                jsxRuntime.jsx("path", {
                    d: "M12.0238 5.66675H3.97619C2.60863 5.66675 1.5 6.71799 1.5 8.01476V12.6521C1.5 13.9488 2.60863 15.0001 3.97619 15.0001H12.0238C13.3914 15.0001 14.5 13.9488 14.5 12.6521V8.01476C14.5 6.71799 13.3914 5.66675 12.0238 5.66675Z",
                    stroke: "currentColor",
                    strokeWidth: "1.4"
                }),
                jsxRuntime.jsx("path", {
                    d: "M5.04546 5.725V3.765C5.04546 2.23667 6.31277 1 7.88182 1C9.45087 1 10.7182 2.23667 10.7182 3.765V5.725",
                    stroke: "currentColor",
                    strokeWidth: "1.4",
                    strokeMiterlimit: "10"
                })
            ]
        })
    });
};

module.exports = MediumPrivate;
